import { render } from "./HeroiconsSolidChartBar.vue?vue&type=template&id=24d7243f"
const script = {}

import exportComponent from "/home/malezha/zfort/digitalfax/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidChartBar.vue"]])

export default __exports__